module.exports = __webpack_public_path__ + "officialStatic/img/logo23.b60fa68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/logo23.png
// module id = 2Bc8
// module chunks = 0